const CONTACT_ERROR_CODE = 'CONTACT_MERGE_DECISION_REQUIRED';

const cloneForPathUpdate = (value) => {
  if (Array.isArray(value)) return value.map(cloneForPathUpdate);
  if (value && typeof value === 'object') return { ...value };
  return value;
};

const setValueAtPath = (target, path, nextValue) => {
  const segments = String(path || '').split('.').filter(Boolean);
  if (segments.length === 0) {
    return target;
  }

  const root = cloneForPathUpdate(target);
  let current = root;

  for (let index = 0; index < segments.length - 1; index += 1) {
    const segment = segments[index];
    const nextSegment = segments[index + 1];
    const key = /^\d+$/.test(segment) ? Number(segment) : segment;
    const currentValue = current[key];

    if (Array.isArray(currentValue)) {
      current[key] = [...currentValue];
    } else if (currentValue && typeof currentValue === 'object') {
      current[key] = { ...currentValue };
    } else {
      current[key] = /^\d+$/.test(nextSegment) ? [] : {};
    }

    current = current[key];
  }

  const lastSegment = segments[segments.length - 1];
  const lastKey = /^\d+$/.test(lastSegment) ? Number(lastSegment) : lastSegment;
  current[lastKey] = nextValue;
  return root;
};

export const resolveContactConflictResponse = async (response, payload) => {
  if (response.status !== 409) {
    return { shouldRetry: false, response };
  }

  let errorData = null;
  try {
    errorData = await response.json();
  } catch (error) {
    return { shouldRetry: false, response };
  }

  if (errorData?.errorCode !== CONTACT_ERROR_CODE) {
    return { shouldRetry: false, response, errorData };
  }

  const details = errorData.details || {};
  const candidates = details.candidates || [];
  const suggestedCandidate = candidates[0] || null;
  const candidateSummary = candidates
    .map((candidate) => `${candidate.fullName || 'Unnamed'}${candidate.dateOfBirth ? ` (${candidate.dateOfBirth})` : ' (DOB unknown)'}`)
    .join('\n');

  const merge = window.confirm(
    `A contact with the name "${details.name || 'Unknown'}" already exists.\n\n` +
      `${candidateSummary ? `Existing contacts:\n${candidateSummary}\n\n` : ''}` +
      `Press OK to merge with the existing contact${suggestedCandidate ? ` (${suggestedCandidate.fullName}${suggestedCandidate.dateOfBirth ? `, ${suggestedCandidate.dateOfBirth}` : ''})` : ''}.\n` +
      `Press Cancel to create a new contact.`
  );

  const resolution = merge
    ? { action: 'merge_existing', targetContactId: suggestedCandidate?.id || null }
    : { action: 'create_new' };

  return {
    shouldRetry: true,
    payload: setValueAtPath(payload, details.resolutionPath || 'contactResolution', resolution),
    errorData
  };
};
